module.exports = __webpack_public_path__ + "static/whatsapp-light-2db6e2f494a9e55f9dcab7d65602e5ec.png";